import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import Alert from '@amzn/meridian/alert';
import Column from '@amzn/meridian/column';
import { useBagStore, usePaymentStore } from 'src/store';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
import { useOffRampToAmazon } from 'src/hooks/useOffRampToAmazon';
import { DeliveryAddressErrorMessage, getPreviewOrderErrorType, PaymentMethodErrorMessage, PreviewOrderErrorType, PreviewOrderStatus, } from 'src/utils/previewOrderErrorUtils';
import { Link } from 'src/common/styled';
export const PreviewPageAlerts = ({ previewOrderStatus, errorReason, offerDetailsChanged, }) => {
    const [bundle, isBundleLoading] = useBundle('pages.previewOrderPage');
    const { selectedPaymentMethodId } = usePaymentStore();
    const { listBag } = useBagStore();
    const bagContents = listBag();
    const pdpAsin = bagContents[0].asin;
    const redirectUrls = useRetailRedirectUrls([RetailRoutes.PAYMENT_SELECTION_WALLET, RetailRoutes.ADDRESS_LIST, RetailRoutes.DETAIL_PAGE], pdpAsin);
    const offRampToAmazon = useOffRampToAmazon();
    const openExternalLink = (e) => {
        e.preventDefault();
        const url = e.currentTarget.href;
        offRampToAmazon(url, ReportActionSource.PreviewOrderPage);
    };
    const formattedLink = (chunks, url, id) => (_jsx(Link, { "data-testid": id, underline: true, href: url, onClick: openExternalLink, children: chunks }, id));
    if (isBundleLoading)
        return null;
    const unfixableErrorMessage = bundle.formatMessage('couldNotBeProcessedViewOnAmazon', {
        a: (chunk) => formattedLink(chunk, redirectUrls.DETAIL_PAGE, 'detail-page-link'),
    });
    const getErrorMessage = (errorCode) => {
        switch (getPreviewOrderErrorType(errorCode)) {
            case PreviewOrderErrorType.PAYMENT_METHOD: {
                const paymentError = PaymentMethodErrorMessage[errorCode];
                return paymentError.containsExternalLink
                    ? bundle.formatMessage(paymentError.translationKey, {
                        method: selectedPaymentMethodId ? 'selected' : 'other',
                        a: (chunk) => formattedLink(chunk, redirectUrls.PAYMENT_SELECTION_WALLET, 'wallet-link'),
                    })
                    : bundle.getMessage(paymentError.translationKey);
            }
            case PreviewOrderErrorType.DELVERY_ADDRESS: {
                const deliveryError = DeliveryAddressErrorMessage[errorCode];
                return deliveryError.containsExternalLink
                    ? bundle.formatMessage(deliveryError.translationKey, {
                        a: (chunk) => formattedLink(chunk, redirectUrls.ADDRESS_LIST, 'address-list-link'),
                    })
                    : bundle.getMessage(deliveryError.translationKey);
            }
            default:
                return unfixableErrorMessage;
        }
    };
    return (_jsxs(Column, { spacing: "350", children: [offerDetailsChanged && (_jsx(Alert, { type: "neutral", "data-testid": "order-update-alert", children: _jsxs(Column, { children: [_jsx("b", { children: bundle.getMessage('orderUpdateAlertMessage') }), bundle.getMessage('previewAlert')] }) })), previewOrderStatus !== PreviewOrderStatus.SUCCESS && (_jsx(Column, { spacingInset: "none none 300 none", children: _jsx(Alert, { type: (errorReason === null || errorReason === void 0 ? void 0 : errorReason.code) && previewOrderStatus === PreviewOrderStatus.FIXABLE_ERROR ? 'warning' : 'error', "data-testid": "preview-order-error-alert", children: (errorReason === null || errorReason === void 0 ? void 0 : errorReason.code) && previewOrderStatus === PreviewOrderStatus.FIXABLE_ERROR
                        ? getErrorMessage(errorReason.code)
                        : unfixableErrorMessage }) }))] }));
};
